export default __webpack_public_path__ + "static/media/logoMobile.5b8aac86.png";